import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Observable, of } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { NewsService } from '@mitsubishi/news/data-access';

@Component({
  selector: 'apm-news-img',
  templateUrl: './news-img.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, LazyLoadImageModule],
})
export class NewsImgComponent implements OnInit {
  @HostBinding('class.apm-news-img') hostClass = true;

  @Input() fileName!: string;
  @Input() imgAlt!: string;

  $imgSrc!: Observable<string>;
  defaultImg = 'assets/images/img-loading.gif';

  constructor(private newsService: NewsService) {}

  ngOnInit(): void {
    this.$imgSrc = this.fileName
      ? this.newsService.getCachedNewsImageUrl(this.fileName)
      : of('assets/images/image-unavailable.png');
  }
}
